(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[42061],{

/***/ 80297:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.H = function HiExclamation (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z","clipRule":"evenodd"}}]})(props);
};


/***/ }),

/***/ 32757:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.V = function HiXCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z","clipRule":"evenodd"}}]})(props);
};


/***/ }),

/***/ 42061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Detail_Prices; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Detail/Title.js
var Title = __webpack_require__(23548);
// EXTERNAL MODULE: ./components/Detail/Prices.module.css
var Prices_module = __webpack_require__(15386);
var Prices_module_default = /*#__PURE__*/__webpack_require__.n(Prices_module);
// EXTERNAL MODULE: ./components/Detail/PriceTable.module.css
var PriceTable_module = __webpack_require__(1616);
var PriceTable_module_default = /*#__PURE__*/__webpack_require__.n(PriceTable_module);
// EXTERNAL MODULE: ./icons/icons.js
var icons = __webpack_require__(17601);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
// EXTERNAL MODULE: ./components/api.js
var api = __webpack_require__(9012);
// EXTERNAL MODULE: ./components/ErrorComp.js
var ErrorComp = __webpack_require__(91450);
// EXTERNAL MODULE: ./components/DefaultCurrencyFormat.js
var DefaultCurrencyFormat = __webpack_require__(16543);
;// CONCATENATED MODULE: ./components/Detail/PriceTable.js








var PriceTable = function(param) {
    var currency = param.currency, id = param.id, start2 = param.start2;
    var ref = (0,react.useState)(false), data = ref[0], setData = ref[1];
    var ref1 = (0,react.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(false), error = ref2[0], setError = ref2[1];
    (0,react.useEffect)(function() {
        setData(false);
        setError(false);
        setLoading(true);
        (0,api/* GetPriceList */._Q)(id, currency, start2).then(function(response) {
            if (response.data.error) {
                setError(response.data.error);
                setData([]);
            } else {
                setTimeout(function() {
                    setData(response.data);
                }, 200);
            }
            setLoading(false);
        }).catch(function(error) {
            setError(error.message);
            setLoading(false);
        });
    }, [
        currency,
        id,
        start2
    ]);
    var Loading = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
            count: 5,
            height: 67
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "min-h-[306px]",
        children: [
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {}),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComp/* default */.Z, {
                children: error
            }),
            data.data && data.data.map(function(item, key) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((PriceTable_module_default()).PriceItem, " group/parent"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col mr-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-sm font-medium 2xl:text-base",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((PriceTable_module_default()).subTitle, " "),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                            className: "w-full text-xs",
                                            children: item.subTitle
                                        }),
                                        item.info && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "relative inline-block cursor-pointer group",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                                                    name: "info",
                                                    size: 16
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "group-hover:block hidden absolute bottom-full bg-brand-black text-white rounded-md py-1 left-0 w-[300px] px-2 -translate-x-1/2 ",
                                                    children: item.info
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "px-3 text-sm font-semibold",
                            children: [
                                (item === null || item === void 0 ? void 0 : item.oran) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "block text-xs text-center text-red-600 line-through ".concat((PriceTable_module_default()).oldPrice),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                        value: item.dailyPriceIndirimsiz,
                                        Symbol: item.Symbol
                                    })
                                }) : "",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                    value: item.dailyPrice,
                                    Symbol: item.Symbol
                                })
                            ]
                        })
                    ]
                }, key);
            })
        ]
    });
};
/* harmony default export */ var Detail_PriceTable = (PriceTable);

// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
;// CONCATENATED MODULE: ./components/Detail/Prices.js






var Prices = function(param) {
    var showAvailability = param.showAvailability, setShowAvailability = param.setShowAvailability, ProductId = param.ProductId, start2 = param.start2;
    var ref = (0,TranslationContext/* useTranslation */.m)(), pricesTitle = ref.pricesTitle, availabilityCalendar = ref.availabilityCalendar, nightly = ref.nightly;
    var isUkSite = "3" == 2;
    var ref1 = (0,react.useState)(isUkSite ? "pound" : "tl"), currency = ref1[0], setCurrency = ref1[1];
    var ShowAvailabilityToggle = function() {
        setShowAvailability(!showAvailability);
    };
    var CurrencyList = isUkSite ? [
        {
            name: "pound",
            text: "GBP"
        },
        {
            name: "tl",
            text: "TL"
        },
        {
            name: "dolar",
            text: "USD"
        },
        {
            name: "euro",
            text: "EUR"
        }, 
    ] : [
        {
            name: "tl",
            text: "TL"
        },
        {
            name: "dolar",
            text: "USD"
        },
        {
            name: "euro",
            text: "EUR"
        },
        {
            name: "pound",
            text: "GBP"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "xl:mr-9 flex-1 lg:mb-5 xl:mb-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                        children: pricesTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: ShowAvailabilityToggle,
                        className: "bg-orange rounded-sm text-white py-2 self-center px-4 text-sm mb-3 lg:hidden",
                        children: availabilityCalendar
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex mt-6 lg:mt-2 z-10 relative " + (Prices_module_default()).PricesTabs,
                children: CurrencyList.map(function(item, key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function(e) {
                            return setCurrency(item.name);
                        },
                        className: item.name === currency ? (Prices_module_default()).active : "",
                        children: item.text
                    }, key);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col -mt-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "ml-auto px-5 2xl:px-6 text-sm font-semibold text-primary",
                            children: nightly
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Detail_PriceTable, {
                        currency: currency,
                        id: ProductId,
                        start2: start2
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Detail_Prices = (Prices);


/***/ }),

/***/ 91450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _react_icons_all_files_hi_HiXCircle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32757);
/* harmony import */ var _react_icons_all_files_hi_HiExclamation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80297);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73040);





var ErrorComp = function(param) {
    var children = param.children, _type = param.type, type = _type === void 0 ? "error" : _type;
    var ref = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .m)(), errorTitle = ref.errorTitle, attention = ref.attention;
    if (!children) return null;
    var styles = {
        error: {
            container: "bg-red-50 border-red-200",
            iconBg: "text-red-400",
            titleColor: "text-red-800",
            textColor: "text-red-700",
            title: "Hata",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_hi_HiXCircle__WEBPACK_IMPORTED_MODULE_3__/* .HiXCircle */ .V, {
                className: "h-5 w-5",
                "aria-hidden": "true"
            })
        },
        warning: {
            container: "bg-yellow-50 border-yellow-200",
            iconBg: "text-yellow-400",
            titleColor: "text-yellow-800",
            textColor: "text-yellow-700",
            title: "Uyar\u0131",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_hi_HiExclamation__WEBPACK_IMPORTED_MODULE_4__/* .HiExclamation */ .H, {
                className: "h-5 w-5",
                "aria-hidden": "true"
            })
        }
    };
    // type prop'u hatalı gelirse varsayılan olarak 'error' kullan
    var activeStyle = styles[type] || styles.error;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "rounded-md p-4 border ".concat(activeStyle.container, " mb-4"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex-shrink-0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: activeStyle.iconBg,
                        children: activeStyle.icon
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "ml-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "text-sm font-medium ".concat(activeStyle.titleColor),
                            children: type === "warning" ? attention : errorTitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-2 text-sm ".concat(activeStyle.textColor),
                            children: children
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorComp);


/***/ }),

/***/ 1616:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PriceItem":"PriceTable_PriceItem__6o0sC","subTitle":"PriceTable_subTitle__bv7PB","oldPrice":"PriceTable_oldPrice__vpXUP"};

/***/ }),

/***/ 15386:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PricesTabs":"Prices_PricesTabs__b6VLa","active":"Prices_active__ic9If"};

/***/ })

}]);